import { useParams } from 'react-router-dom'
// import { submitMilestoneStep } from '../../../services/api/collaboration'
import React, { useMemo, useState } from 'react'

import CampaignGig from './components/CampaignGig'
import inModal from 'utils/hoc/inModal'
import { RootState, store } from 'store'
import { usePrivileges } from 'hooks/useAuth'
import { PRIVILEGE } from 'constants/privilege'
import { CampaignGigOption, Gig, Milestone, MilestoneStep } from 'types/collaboration'
import { processCollaborationMilestoneStep } from 'services/api/collaboration'
import { useSelector } from 'react-redux'
import CampaignGigs from './gigs/CampaignGigs'
import { toast } from 'react-toastify'

interface GigSelectionProps {
    gigs: Gig[]
    activeMilestone: Milestone
    isActive: boolean,
    onClose: (refetch?: boolean) => void,
    onPlayButtonClick: (gig: Gig) => void,
    handleDownload: (gig: Gig) => void,
    step: MilestoneStep
}

const GigSelection: React.FC<GigSelectionProps> = ({ activeMilestone, gigs, step, onPlayButtonClick, handleDownload, onClose }) => {
    const privileges = usePrivileges() 
    const { campaignId, collaborationId, milestoneId } = useParams();
    const selectedHubId = useSelector((state: RootState) => state.auth.selectedHubId);

    const [selectedGigs, setSelectedGigs] = useState<number[]>([]);
    const [options, setOptions] = useState<Record<string | number, CampaignGigOption[]> | null>(null);

    const [submitting, setSubmitting] = useState(false);

    const onCheckHandler = (gig: Gig) => {
        if (selectedGigs.includes(gig.id)) {
            setSelectedGigs([...selectedGigs.filter((g) => g !== gig.id)])
        } else {
            setSelectedGigs([...selectedGigs, gig.id]);
        }
    }

    const onSubmit = async () => {
        
        if (!campaignId || !selectedGigs.length || !collaborationId || !milestoneId || !selectedHubId) return;
        try {
            setSubmitting(true);
            let gig_options: any = {};
            if(options){
                for(let [key, gigOptions] of Object.entries(options)){
                    if(!selectedGigs.includes(Number(key))) continue;
                    if(Array.isArray(gigOptions)){
                        for(let i in gigOptions){
                            let gigOption = gigOptions[i];
                            gig_options[`options[${key}][${i}][label]`] = gigOption.label;
                            gig_options[`options[${key}][${i}][values][0]`] = gigOption.values[0];
                        }
                    }
                }
            }
            await processCollaborationMilestoneStep(selectedHubId, campaignId, collaborationId, milestoneId, { step: step.gig_step.slug, campaign_gig_ids: selectedGigs,  ...(gig_options ? {...gig_options} : {}) });
            onClose(true);
         } catch (error:any) {
            console.log(error);
            toast.error(error?.response?.data?.message ?? "Unknown error occurred.")
        } finally {
            setSubmitting(false);
        }
    }


    return (
        <React.Fragment>
            <span className='gig-selection-title'>Choose any {activeMilestone.maximum_gigs} out of {gigs.length}</span>
            <CampaignGigs
                quickRepost={!!activeMilestone.specifications.quick_repost}
                onSelect={onCheckHandler}
                selectedGigs={selectedGigs}
                gigType={activeMilestone.gig_type}
                gigs={gigs}
                onPlayButtonClick={onPlayButtonClick}
                options={options}
                setOptions={setOptions}
            />
            <div className="milestone-step-actions">
                <button className="theme-btn theme-btn-primary-outlined" onClick={() => onClose()}>Cancel</button>
                <button className="theme-btn theme-btn-primary" disabled={selectedGigs.length !== activeMilestone.maximum_gigs || submitting || !privileges.includes(PRIVILEGE.CAMPAIGN.COLLABORATION.PROCESS)} onClick={onSubmit}>Submit</button>
            </div>
        </React.Fragment>

    )
}

const GigSelectionModal: React.FC<GigSelectionProps> = (props) => {
    const { activeMilestone } = props
    const title = `Choose ${activeMilestone.gig_type.object_name || 'Item'}`

    const ModalComponent = useMemo(() => inModal(GigSelection, title), [title])
    return <ModalComponent {...props} />
}


export default GigSelectionModal;